export default __webpack_public_path__ + "e5f343c76352ef69799de8242474dcc5.svg";